export interface Chain<T, R> {
  chain<S>(fn: (x: R) => S): Chain<T, S>;
  value(): R;
}

export default function chain<T>(value: T): Chain<T, T> {
  return {
    chain(fn) {
      return chain(fn(value));
    },
    value: () => value,
  };
}
